import { useRouter } from 'next/router'
import React from 'react'
import { AnimatePresence, motion } from 'motion/react'
import AppIntegrationDetailView from 'src/components/apps-integrations/AppIntegrationDetailView'
import AppDetailSkeleton from 'src/components/apps-integrations/AppDetailSkeleton'
import { useAppDetailV2 } from 'src/lib/hooks/useAppDetailV2'
import { useAppsV2 } from 'src/lib/hooks/useAppsV2'
import { useUser } from 'src/lib/contexts/UserContext'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const AppIntegrationDetailPage = () => {
  const router = useRouter()
  const raw = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id

  const isSlug = Boolean(raw && !UUID_REGEX.test(raw))
  const { items, isLoading: isListLoading } = useAppsV2()
  const resolvedId = isSlug ? items.find(item => item.slug?.toLowerCase() === raw?.toLowerCase())?.id ?? raw : raw

  const { detail, isLoading, mutate } = useAppDetailV2(isSlug && isListLoading ? undefined : resolvedId)
  const { mutateUser } = useUser()
  const {
    getters: { shopfloApps }
  } = useOrganisationContext()

  const showSkeleton = isLoading || (isSlug && isListLoading)
  const etdAppId = shopfloApps?.find((app: any) => app.name === 'DYNAMIC_ETD')?.id

  return (
    <div className='relative min-h-0 flex-1'>
      <AnimatePresence mode='popLayout'>
        {showSkeleton ? (
          <motion.div
            key='app-detail-skeleton'
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.2, ease: 'easeOut' } }}
            transition={{ duration: 0 }}
            className='absolute inset-0 flex min-h-0 flex-col'
          >
            <AppDetailSkeleton />
          </motion.div>
        ) : !detail ? (
          <motion.div
            key='app-detail-missing'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.28, ease: 'easeOut' } }}
            exit={{ opacity: 1, transition: { duration: 0 } }}
            className='flex h-64 w-full items-center justify-center'
          >
            <p className='text-text-sm-regular text-zinc-500'>Not found.</p>
          </motion.div>
        ) : (
          <motion.div
            key='app-detail-content'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.28, ease: 'easeOut' } }}
            exit={{ opacity: 1, transition: { duration: 0 } }}
            className='absolute inset-0 flex min-h-0 flex-col'
          >
            <AppIntegrationDetailView
              detailConfig={detail}
              additionalAppPath={etdAppId ? `/apps-integrations/detail?id=${etdAppId}` : '/apps-integrations'}
              onActivationChange={async () => {
                await Promise.all([mutate(), mutateUser()])
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default AppIntegrationDetailPage
